export class RoutesPath {
  static readonly HOME = '';
  static readonly LOGIN = 'login';
  static readonly DASHBOARD = 'dashboard';
  static readonly STORES = 'stores';
  static readonly STORE_ID = ':storeId';
  static readonly OVERVIEW = 'overview';
  static readonly VENDORS = 'team';
  static readonly BILLING_HISTORY = 'billing-history';
}
